import { useMemo } from "react";
import type { DocumentLinkTargetKind } from "@/engine/types";
import { isOwnExecutionTask } from "@/features/access/own-assignment";
import { useOpenPlanLifecycle, usePlanActor, useSelfRef } from "@/features/access/use-plan-access";
import { useCatalogStore } from "@/store/catalog-store";
import { useProjectStore } from "@/store/project-store";
import { DOCUMENT_HOST } from "./doc-model";
import type { DocReader } from "./doc-visibility";

/** 로컬 플랜의 작성자는 표시 이름이다. 클라우드 분기는 같은 모양에 host만 바꿔 검증한다. */
export function useDocReader(): DocReader {
  const actor = usePlanActor();
  const status = useOpenPlanLifecycle();
  const self = useSelfRef();
  const displayName = useCatalogStore((s) => s.profile.displayName);
  const executionTasks = useProjectStore((s) => s.project.executionTasks);
  const ownExecutionTaskIds = useMemo(
    () => executionTasks.filter((task) => isOwnExecutionTask(task.assignees, self)).map((task) => task.id),
    [executionTasks, self],
  );
  return {
    role: actor.role,
    actorId: displayName.trim(),
    host: DOCUMENT_HOST,
    status,
    authorOnPlan: () => true,
    ownExecutionTaskIds,
  };
}

export function linkedExecutionIds(docId: string, links: readonly { documentId: string; targetKind: DocumentLinkTargetKind; targetId: string; missingAt?: string }[]): string[] {
  return links.filter((link) => link.documentId === docId && link.targetKind === "executionTask" && !link.missingAt).map((link) => link.targetId);
}
